import React, { Component } from 'react'
import { Context } from '../Context'
import PhotoGrid from '../PhotoGrid'

export default class ReferencesDetail extends Component {
    static contextType = Context
    constructor(props) {
        super(props)
        this.state = {
            data: null,
        }
    }

    componentWillMount() {
        this.setState({
            data:
                this.props.match.params.type === 'bauservice'
                    ? this.context.state.constructionServiceProjects[this.props.match.params.id]
                    : this.context.state.inStockProjects[this.props.match.params.id],
        })
    }

    render() {
        if (!this.state.data) return
        return (
            <div className="main">
                <div className="container-fluid pos-relative" style={{ overflowY: 'scroll' }}>
                    <div className="page-body p-3">
                        <PhotoGrid photosData={this.state.data} />
                    </div>
                </div>
            </div>
        )
    }
}
